// ============================================================
//  SITE-SETTINGS — Firestore-Dokument "siteSettings/main"
//  Ersetzt Sanity fetchSiteSettings(). Ein einzelnes Dokument
//  (kein Array), fixe ID "main" statt Sanity-Singleton-Query.
// ============================================================
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

const DOC_REF = "siteSettings/main";

export async function fetchSiteSettings() {
  const snap = await getDoc(doc(db, DOC_REF));
  return snap.exists() ? snap.data() : null;
}

export async function updateSiteSettings(daten) {
  await setDoc(doc(db, DOC_REF), daten, { merge: true });
}
